import { AppEnv } from '../types/app-env'

const preprod = {
	apiKey: 'AIzaSyCD9OK-UT1cb3PE3-i0V7S0RqJpqX5XbHg',
	authDomain: 'cocoon-space-preprod-mobile.firebaseapp.com',
	databaseURL:
		'https://cocoon-space-preprod-mobile-default-rtdb.europe-west1.firebasedatabase.app',
	projectId: 'cocoon-space-preprod-mobile',
	storageBucket: 'cocoon-space-preprod-mobile.firebasestorage.app',
	messagingSenderId: '283339168852',
	appId: '1:283339168852:web:73557ef00ff029d1baa1c1',
	measurementId: 'G-9NN0TJCQQN',
} as const

const prod = {
	apiKey: 'AIzaSyBkxYg8-y-rmGSFoAC0ueHMQQrOM3A1mdg',
	authDomain: 'cocoon-space-mobile.firebaseapp.com',
	databaseURL: 'https://cocoon-space-mobile.firebaseio.com',
	projectId: 'cocoon-space-mobile',
	storageBucket: 'cocoon-space-mobile.firebasestorage.app',
	messagingSenderId: '281054453170',
	appId: '1:281054453170:web:9b679454be0b11598d18ab',
	measurementId: 'G-Q2LHN5RYZ9',
} as const

const configs = {
	development: preprod,
	preprod,
	prod,
} as const

export const getFirebaseConfig = (env: AppEnv = 'prod') =>
	configs[env] ?? configs.prod
